videojs.addLanguage('cy', {
  "Audio Player": "Chwaraewr sain",
  "Video Player": "Chwaraewr fideo",
  "Play": "Chwarae",
  "Pause": "Oedi",
  "Replay": "Ailchwarae",
  "Current Time": "Amser Cyfredol",
  "Duration": "Parhad",
  "Remaining Time": "Amser ar ôl",
  "Stream Type": "Math o Ffrwd",
  "LIVE": "YN FYW",
  "Loaded": "Llwythwyd",
  "Progress": "Cynnydd",
  "Progress Bar": "Bar Cynnydd",
  "progress bar timing: currentTime={1} duration={2}": "{1} o {2}",
  "Fullscreen": "Sgrîn Lawn",
  "Non-Fullscreen": "Ffenestr",
  "Mute": "Pylu",
  "Unmute": "Dad-bylu",
  "Playback Rate": "Cyfradd Chwarae",
  "Subtitles": "Isdeitlau",
  "subtitles off": "Isdeitlau i ffwrdd",
  "Captions": "Capsiynau",
  "captions off": "Capsiynau i ffwrdd",
  "Chapters": "Penodau",
  "Descriptions": "Disgrifiadau",
  "descriptions off": "disgrifiadau i ffwrdd",
  "Audio Track": "Trac Sain",
  "Volume Level": "Lefel Sain",
  "You aborted the media playback": "Atalwyd y fideo gennych",
  "A network error caused the media download to fail part-way.": "Mae gwall rhwydwaith wedi achosi methiant lawrlwytho.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Ni lwythodd y fideo, oherwydd methiant gweinydd neu rwydwaith, neu achos nid yw'r system yn cefnogi'r fformat.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Atalwyd y fideo oherwydd problem llygredd data neu oherwydd nid yw'ch porwr yn cefnogi nodweddion penodol o'r fideo.",
  "No compatible source was found for this media.": "Nid oedd modd canfod ffynhonnell cytûn am y fideo hwn.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Mae'r fideo wedi ei amgryptio ac nid oes allweddion gennym.",
  "Play Video": "Chwarae Fideo",
  "Close": "Cau",
  "Close Modal Dialog": "Cau Blwch Deialog Moddol",
  "Modal Window": "Ffenestr Foddol",
  "This is a modal window": "Mae hon yn ffenestr foddol",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Gallech chi gau'r ffenestr foddol hon trwy wasgu Escape neu glicio'r botwm cau.",
  ", opens captions settings dialog": ", yn agor gosodiadau capsiynau",
  ", opens subtitles settings dialog": ", yn agor gosodiadau isdeitlau",
  ", opens descriptions settings dialog": ", yn agor gosodiadau disgrifiadau",
  ", selected": ", detholwyd",
  "captions settings": "gosodiadau capsiynau",
  "subtitles settings": "gosodiadau isdeitlau",
  "descriptions settings": "gosodiadau disgrifiadau",
  "Text": "Testun",
  "White": "Gwyn",
  "Black": "Du",
  "Red": "Coch",
  "Green": "Gwyrdd",
  "Blue": "Glas",
  "Yellow": "Melyn",
  "Magenta": "Piws",
  "Cyan": "Cyan",
  "Background": "Cefndir",
  "Window": "Ffenestr",
  "Transparent": "Tryloyw",
  "Semi-Transparent": "Hanner-dryloyw",
  "Opaque": "Di-draidd",
  "Font Size": "Maint y Ffont",
  "Text Edge Style": "Arddull Ymylon Testun",
  "None": "Dim",
  "Raised": "Uwch",
  "Depressed": "Is",
  "Uniform": "Unffurf",
  "Dropshadow": "Cysgod cefn",
  "Font Family": "Teulu y Ffont",
  "Proportional Sans-Serif": "Heb-Seriff Cyfraneddol",
  "Monospace Sans-Serif": "Heb-Seriff Unlled",
  "Proportional Serif": "Seriff Gyfraneddol",
  "Monospace Serif": "Seriff Unlled",
  "Casual": "Llawysgrif",
  "Script": "Sgript",
  "Small Caps": "Prif Lythyrennau Bychain",
  "Reset": "Ailosod",
  "restore all settings to the default values": "Adfer yr holl osodiadau diofyn",
  "Done": "Gorffenwyd",
  "Caption Settings Dialog": "Blwch Gosodiadau Capsiynau",
  "Beginning of dialog window. Escape will cancel and close the window.": "Dechrau ffenestr deialog. Bydd Escape yn canslo a chau'r ffenestr.",
  "End of dialog window.": "Diwedd ffenestr deialog.",
  "{1} is loading.": "{1} yn llwytho."
});